<template>
  <div class="tab-content">
    <div :class="['tab-pane fade', { 'show active': fit20.selectTabId == 'tab_id0' }]" id="studios">
      <Studios v-if="fit20 && fit20.studios.length" :fit20="fit20" :selectTab="selectTab" :formatDate="formatDate">
      </Studios>
    </div>
    <div :class="['tab-pane fade', { 'show active': fit20.selectTabId == 'tab_id1' }]" id="members">
      <Members v-if="fit20.studio.id" :fit20="fit20" :admin="false" :selectTab="selectTab"
        :clearLocalStorage="clearLocalStorage"></Members>
    </div>
    <div v-for="(members, index) in  fit20.currentMembers " :key="'tabpanel-' + index"
      :class="['tab-pane fade', { 'show active': fit20.selectTabId == 'tab_id' + (index + 2) }]">
      <div v-for="member in members" :id="'member-' + index">
        <Session :member="member" :fit20="fit20" :formatDate="formatDate" :tabNum="index" :selectTab="selectTab"
          :admin="false">
        </Session>
        <div class="spacer"></div>
      </div>

    </div>
  </div>
</template>

<script>
import Admin from './admin/Admin';
import Studios from './Studios';
import Members from './Members.vue';
import Session from './Session.vue';
export default {
  name: 'Main',
  components: {
    Admin,
    Studios,
    Members,
    Session
  },
  props: ["fit20", "selectTab", "formatDate", "clearLocalStorage"],
  data() {
    return {
    };
  },
};
</script>

<style>
.tab-content {
  margin-top: 2px;
}

.tab-pane {
  display: none;
  color: black;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
}

.display-none {
  display: none;
}

.spacer {
  margin-left: 10px;
  border: solid 1px var(--fit20-lighter-gray);
}
</style>
